import { api } from "@/lib/api"
import { SettingItem } from "../settings-switches/setting-item"
import { SettingsContainer } from "../settings-switches/settings-container"

export function CloseLoopSummaryCard({ className }: { className?: string }) {
	const { data } = api.thread.closeLoopSummary.useQuery(undefined, {
		staleTime: 60 * 1000,
	})

	return (
		<SettingsContainer className={className}>
			<SettingItem
				title="Loops closed"
				description="Threads that heard back once the work was released."
				action={
					!data ? (
						<div
							className="h-8 w-14 flex-none animate-pulse rounded bg-gray-100 dark:bg-gray-800"
							data-testid="close-loop-summary-loading"
						/>
					) : (
						<span className="flex-none text-[32px] font-medium tabular-nums leading-none text-primary">
							{data.threads.toLocaleString("en-US")}
						</span>
					)
				}
			/>
		</SettingsContainer>
	)
}
